import './sentry';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { registerSW } from 'virtual:pwa-register';

import * as Sentry from '@sentry/react';

// react dnd
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// project imports
import App from './App';
import { store, persistor } from './store';

// style + assets
import 'assets/scss/style.scss';

// Handle Vite dynamic import errors by reloading the page
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

registerSW({
  onRegisteredSW(_scriptUrl, registration) {
    if (registration) {
      setInterval(
        () => {
          registration.update();
        },
        5 * 60 * 1000
      );
    }
  },
  onRegisterError(error) {
    console.error('Error during service worker registration:', error);
  }
});

// ==============================|| REACT DOM RENDER  ||============================== //

// const root = ReactDOM.createRoot(document.getElementById('root'));

const container = document.getElementById('root');
const root = createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler()
});

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
